import type { ReactNode } from 'react';

import type { Site } from '@hotjar/site';
import { TrafficCoverageSumUp } from '@hotjar/webapp/features/SamplingWidget/SessionTrafficCoverage/TrafficCoverageSumUp';
import { noop } from '@hotjar/webapp/lib/function';

import { TrafficBarStyles as S } from '../styles';

interface Props {
  site: Site | undefined;
  dailyTraffic: number;
  ccDailyAllowance: number;
  coveragePercentage: number;
  isCoverageMeasureComplete: boolean;
  hasPartialMeasure: boolean;
  hasDivider: boolean;
  isError?: boolean;
  children: ReactNode;
}

export const TrafficBar = ({
  site,
  dailyTraffic,
  ccDailyAllowance,
  coveragePercentage,
  isCoverageMeasureComplete,
  hasPartialMeasure,
  hasDivider,
  isError,
  children,
}: Props): JSX.Element => {
  return (
    <S.Container hasDivider={hasDivider} data-testid="plan-selection-modal-observe-content">
      {children}
      {!isError && (
        <S.TrafficCoverageWrapper>
          <TrafficCoverageSumUp
            site={site}
            coveragePercentage={coveragePercentage}
            isCoverageMeasureComplete={isCoverageMeasureComplete}
            dailyTraffic={dailyTraffic}
            ccDailyAllowance={ccDailyAllowance}
            trackClick={noop}
            isDropDownShown
            hasPartialMeasure={hasPartialMeasure}
          />
        </S.TrafficCoverageWrapper>
      )}
    </S.Container>
  );
};
